import React from 'react';
import { useRefinementList, useMenu } from 'react-instantsearch-hooks-web';
import { searchUILabels } from '@components/ui/Search';
import './ColorRefinementList.scss';
import slugify from 'slugify';

export function ColorRefinementList(props) {
  const { items, refine } = useMenu({ ...props, limit: 100 });

  if (!items.length) {
    return null;
  }

  const handleRefine = (value) => (ev) => {
    if (ev.code && ev.code !== 'Enter') {
      return;
    }
    refine(value);
  };

  return (
    <div className="ais-RefinementList" data-type="color">
      <header>{searchUILabels[props.attribute].label}</header>
      <ul className="ais-RefinementList-list">
        {items.map((item) => (
          <li
            key={item.value}
            className={cx('ais-RefinementList-item', item.isRefined && 'ais-RefinementList-item--selected')}
            data-color={slugify(item.value, { lower: true, sortBy: ['name:asc'] })}
          >
            <label className="ais-RefinementList-label" tabIndex={0} onKeyDown={handleRefine(item.value)}>
              <input
                className="ais-RefinementList-checkbox"
                type="checkbox"
                value={item.value}
                checked={item.isRefined}
                onChange={handleRefine(item.value)}
              />
              <span className="ais-RefinementList-labelText">{item.label}</span>
              <span className="ais-RefinementList-count">{item.count}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
}

function cx(...classNames) {
  return classNames.filter(Boolean).join(' ');
}
